import Vue from 'vue';
import {
    getCompItemIdFromColKey,
} from './compGridUtils';


const StatusRenderer = Vue.extend({  // for the regular COMPLIANCE ITEM STATUS grid
    template: `
    <div class="h-100 w-100">
        <div v-if="hasMultiple" class="py-1 d-flex flex-column gap-1" style="line-height: 1;">
            <div v-for="status in statusArray" :key="status.id" class="d-flex gap-2 align-items-center justify-content-start">
                <div
                    v-if="status.status.overall_status.variant"
                    :key="status.status.overall_status.label"
                >
                    <b-badge 
                        :id="'vci_status_' + status.id"
                        href="#"
                        :variant="status.status.overall_status.variant"
                        class="text-uppercase"
                        @click="showStatusDetails(status.status)"
                    >{{status.status.overall_status.label}}</b-badge>
                    <!-- <b-popover 
                        v-if="status.status.overall_status.variant"
                        :target="'vci_status_' + status.id" 
                        triggers="hover" 
                        placement="top"
                    >
                        <template #title>{{ status.status.vendor.name }}</template>
                        <dl class="row form-row">
                            <dt class="col-4">Document: </dt>
                            <dd class="col-8">{{status.status.title}}</dd>
                            <dt class="col-4">Status: </dt>
                            <dd class="col-8">{{status.status.overall_status.label}}</dd>
                        </dl>
                    </b-popover> -->
                </div>
                <span v-else key="noBadge" class="font-size-70 text-gray-500">{{status.status.overall_status.label}}</span>
                <div v-if="hasMultiple" class="font-size-80 text-nowrap">{{ status.status.title }}</div>
            </div>
        </div>
        <div v-else-if="hasAnyStatus">
            <div
                v-if="statusArray[0].status.overall_status.variant" 
                :key="statusArray[0].status.overall_status.label" 
            >
                <b-badge 
                    href="#"
                    :id="'vci_status_' + statusArray[0].id"
                    :variant="statusArray[0].status.overall_status.variant"
                    class="text-uppercase"
                    @click="showStatusDetails(statusArray[0].status)"
                >{{statusArray[0].status.overall_status.label}}</b-badge>
                <!-- <b-popover
                    v-if="statusArray[0].status.overall_status.variant" 
                    :target="'vci_status_' + statusArray[0].id" 
                    triggers="hover" 
                    placement="top"
                >
                    <template #title>{{ statusArray[0].status.vendor.name }}</template>
                    <dl class="row form-row">
                        <dt class="col-4">Document: </dt>
                        <dd class="col-8">{{statusArray[0].status.title}}</dd>
                        <dt class="col-4">Status: </dt>
                        <dd class="col-8">{{statusArray[0].status.overall_status.label}}</dd>
                    </dl>
                </b-popover> -->
            </div>
            <span v-else key="noBadge" class="font-size-70 text-gray-500">{{statusArray[0].status.overall_status.label}}</span>
        </div>
        <div v-else class="empty-compitem-cell">
            <span class="text-muted font-size-70">&mdash;</span>
            <!-- <button  
                type="button"
                class="empty-compitem-button btn btn-sm font-size-70"
                
                @click="startAdd"
            >
                ADD
            </button> -->
        </div>
    </div>`,  // previous content for empty stuff:  &mdash; with text-muted font-size-70
    computed: {
        statusArray() {
            // the 'value' is an array of status objects, but maybe empty
            return this.params.value || [];  // just in case it's null from being in a group row, etc.
        },
        hasAnyStatus() {
            return this.statusArray.length > 0;
        },
        hasMultiple() {
            return this.statusArray.length > 1;
        },
        gridComponent() {
            // reference to the parent grid component, so we can call methods on it
            return this.params.context.componentParent;
        },
        compItemId() {
            // the compItem this column represents -- either need to add extra data to the colDef, or parse from col field name
            const colKey = this.params.colDef.field;  // will be the 'compItem_.....'
            return getCompItemIdFromColKey(colKey);
        },
        vendorId() {
            return this.params.data?.id;
        },
        vendorName() {
            return this.params.data?.name;
        },
    },
    methods: {
        showStatusDetails(vciStatus) {
            this.gridComponent.showStatusSidebar(vciStatus);
        },
        startAdd() {
            const rowData = this.params.data;
            this.gridComponent.startAddSpecificCompItem(rowData, this.compItemId);
        },
    },
});


const ReqStatusRenderer = Vue.extend({  // for the REQUIREMENT STATUS grid
    template: `
    <div 
        class="h-100 w-100 py-2 d-flex gap-1 flex-column align-items-center justify-content-center" 
        style="line-height: 1;"
    >
        <div v-if="hasReq" class="text-nowrap text-center">
            <span 
                :id="'need_status_' + uniqueId"
                class="need-status-chip"
                v-b-tooltip="{title: needStatusReason, trigger: 'hover', placement: 'left', id: 'need_status_' + uniqueId}"
            >
                <b-icon :icon="needStatusType.bsv_icon" font-scale="0.8" variant="secondary"></b-icon>
                <span class="special-text">{{ needStatusType.label }}</span>
            </span>
        </div>
        <div v-if="hasMultiple" class="d-flex flex-column gap-1 align-items-center justify-content-center" style="line-height: 1;">
            <div v-for="status in vciStatusArray" :key="status.id" class="d-flex gap-2 align-items-center justify-content-start">
                <div
                    v-if="status.status.overall_status.variant"
                    :key="status.status.overall_status.label"
                >
                    <b-badge 
                        :id="'vci_status_' + status.id"
                        href="#"
                        :variant="status.status.overall_status.variant"
                        class="text-uppercase"
                        @click="showStatusDetails(status.status)"
                        v-b-tooltip="{title: status.status.title, trigger: 'hover', placement: 'left', id: 'vci_status_' + status.id}"
                    >{{status.status.overall_status.label}}</b-badge>
                    <!-- <b-popover 
                        v-if="status.status.overall_status.variant"
                        :target="'vci_status_' + status.id" 
                        triggers="hover" 
                        placement="top"
                    >
                        <template #title>{{ status.status.vendor.name }}</template>
                        <dl class="row form-row">
                            <dt class="col-4">Document: </dt>
                            <dd class="col-8">{{status.status.title}}</dd>
                            <dt class="col-4">Status: </dt>
                            <dd class="col-8">{{status.status.overall_status.label}}</dd>
                        </dl>
                    </b-popover> -->
                </div>
                <span v-else key="noBadge" class="font-size-70 text-gray-500">{{status.status.overall_status.label}}</span>
                <!-- <div v-if="hasMultiple" class="font-size-80 text-nowrap">{{ status.status.title }}</div> -->
            </div>
        </div>
        <div v-else-if="hasAnyStatus" class="">
            <div
                v-if="vciStatusArray[0].status.overall_status.variant" 
                :key="vciStatusArray[0].status.overall_status.label" 
            >
                <b-badge 
                    href="#"
                    :id="'vci_status_' + vciStatusArray[0].id"
                    :variant="vciStatusArray[0].status.overall_status.variant"
                    class="text-uppercase"
                    v-b-tooltip="{title: vciStatusArray[0].status.title, trigger: 'hover', placement: 'left', id: 'vci_status_' + vciStatusArray[0].id}"
                    @click="showStatusDetails(vciStatusArray[0].status)"
                >{{vciStatusArray[0].status.overall_status.label}}</b-badge>
                <!-- <b-popover
                    v-if="vciStatusArray[0].status.overall_status.variant" 
                    :target="'vci_status_' + vciStatusArray[0].id" 
                    triggers="hover" 
                    placement="top"
                >
                    <template #title>{{ vciStatusArray[0].status.vendor.name }}</template>
                    <dl class="row form-row">
                        <dt class="col-4">Document: </dt>
                        <dd class="col-8">{{vciStatusArray[0].status.title}}</dd>
                        <dt class="col-4">Status: </dt>
                        <dd class="col-8">{{vciStatusArray[0].status.overall_status.label}}</dd>
                    </dl>
                </b-popover> -->
            </div>
            <span v-else key="noBadge" class="font-size-70 text-gray-500">{{vciStatusArray[0].status.overall_status.label}}</span>
        </div>
        <div v-else-if="!hasReq">
            <span class="text-muted font-size-70">&mdash;</span>
        </div>
        <!-- NOT NEEDED? as long as we have color codes it should be OK <div v-else class="comp-req-status">
            <span class="special-text font-size-70" :class="reqStatusTextClasses">{{ reqStatus.label }}</span>
        </div> -->
    </div>`,  // previous content for empty stuff:  &mdash; with text-muted font-size-70
    computed: {
        uniqueId() {
            return this.params.value?.id || '';
        },
        outerClass() {
            // return string or array of classes
            if (this.hasReq) {
                return `bg-${this.reqStatus.variant}-100`;
            } else {
                return '';
            }
        },
        reqStatusTextClasses() {
            return this.hasReq ? `text-${this.reqStatus.variant}` : 'opacity-50';
        },
        vciStatusArray() {
            // the 'value' is an array of status objects, but maybe empty
            return this.params.value?.vci_status_objects || [];  // just in case it's null from being in a group row, etc.
        },
        hasAnyStatus() {
            return this.vciStatusArray.length > 0;
        },
        hasMultiple() {
            return this.vciStatusArray.length > 1;
        },
        hasReq() {
            return !!this.params.value?.req_id;
        },
        reqStatus() {
            // includes { key, label, need_status_key, variant }
            return this.params.value?.req_status || {};
        },
        needStatusKey() {
            return this.params.value?.req_status?.need_status_key || '';
        },
        needStatusResult() {  // all will have this, even if no requirement - just relatively empty in that case
            // interesting things in here:  { default_used, need_status_type, override_used, rule_used, reason }
            return this.params.value?.need_status_result || {};
        },
        needStatusReason() {
            // the reason for the need status - if any
            return this.needStatusResult.reason || '';
        },
        needStatusType() {  // all should have this also, but maybe NOT_SET for key
            // interesting things in here:  { key, label, description, bsv_icon, bsv_icon_variant, bsv_bg_variant }
            return this.needStatusResult.need_status_type || {};
        },
        gridComponent() {
            // reference to the parent grid component, so we can call methods on it
            return this.params.context.componentParent;
        },
        compItemId() {
            // the compItem this column represents -- either need to add extra data to the colDef, or parse from col field name
            const colKey = this.params.colDef.field;  // will be the 'compItem_.....'
            return getCompItemIdFromColKey(colKey);
        },
        vendorId() {
            return this.params.data?.id;
        },
        vendorName() {
            return this.params.data?.name;
        },
    },
    methods: {
        showStatusDetails(vciStatus) {
            this.gridComponent.showStatusSidebar(vciStatus);
        },
        startAdd() {
            const rowData = this.params.data;
            this.gridComponent.startAddSpecificCompItem(rowData, this.compItemId);
        },
    },
});

const CompItemHeaderRenderer = Vue.extend({
    template: `
    <div class="h-100 d-flex align-items-center justify-content-center gap-1 w-100">
        <a v-if="internalDetailUrl" key="hasUrl" :href="internalDetailUrl" class="text-primary-darker font-weight-700 w-100 text-center text-wrap" target="_blank">
            {{ headerLabel }}
        </a>
        <div v-else key="noUrl" class="text-center text-wrap">{{ headerLabel }}</div>
    </div>`,
    computed: {
        headerLabel() {
            return this.params.displayName;
        },
        compItemId() {
            // the compItem this column represents -- either need to add extra data to the colDef, or parse from col field name
            const colKey = this.params.column.getId();  // will be the 'compItem_.....'
            return getCompItemIdFromColKey(colKey);
        },
        internalDetailUrl() {
            // get from gridContext... put there when creating the grid
            const compItemsById = this.params.context.compItemsById || {};
            const compItem = compItemsById[this.compItemId] || {};
            return compItem.urls?.internal_detail || '';
        },
    },
    methods: {}
});

const VendorColHeaderRenderer = Vue.extend({
    template: `
    <div class="h-100 d-flex flex-column justify-content-center gap-1 w-100">
        <div class="d-flex flex-row justify-content-between align-items-center w-100">
            <div class="text-left text-wrap">{{ headerLabel }}</div>
            <b-button size="sm" :variant="isFilterActive ? 'sharp-primary' : 'minimal-primary'" @click="resetFilter">Reset</b-button>
        </div>
        <b-form-input
            :style="{ width: '100%' }" 
            type="search" 
            trim
            placeholder="Search vendors..."
            v-model="currentFilterValue" 
            @input="onInputBoxChanged()"
        ></b-form-input>
    </div>`,
    data: function () {
        return {
            currentFilterValue: null,
        }
    },
    computed: {
        headerLabel() {
            return this.params.displayName;
        },
        isFilterActive() {
            return this.currentFilterValue && this.currentFilterValue.length > 0;
        },
    },
    mounted() {
        // gotta setup listener for external filter changes, then destroy when done
        this.params.column.addEventListener('filterChanged', this.onFilterChanged);  // this.onFilterChanged.bind(this) ???
        this.onFilterChanged();  // call it once to sync up
    },
    beforeDestroy() {
        this.params.column.removeEventListener('filterChanged', this.onFilterChanged);
    },
    methods: {
        getFilterInstance() {
            return this.params.api.getFilterInstance(this.params.column.getId());
        },
        resetFilter() {
            this.currentFilterValue = '';
            this.onInputBoxChanged();
        },
        onInputBoxChanged() {
            if (this.currentFilterValue === '') {
                // Remove the filter
                // this.params.parentFilterInstance((instance) => {
                //     instance.onFloatingFilterChanged(null, null);
                // });
                // return;
                const colFilterInst = this.getFilterInstance();
                colFilterInst.setModel(null);
                this.params.api.onFilterChanged();  // gotta tell it the filter changed
                return;
            }
            // if we have a value, set the filter to 'contains' that value
            const colFilterInst = this.getFilterInstance();
            colFilterInst.setModel({
                filterType: 'text', // needed or not???
                type: 'contains',
                filter: this.currentFilterValue,
            });
            this.params.api.onFilterChanged();  // gotta tell it the filter changed

            // this.params.parentFilterInstance((instance) => {
            //     instance.onFloatingFilterChanged('contains', this.currentValue);
            // });
        },
        onFilterChanged() {
            // called when something external to this component changes the filter (like sidebar panel in parent grid)
            const colFilterInst = this.getFilterInstance();  // this.params.api.getFilterInstance(this.params.column.getId());
            const model = colFilterInst.getModel();
            console.log('VendorColHeaderRenderer onFilterChanged', model);
            if (!model) {
                this.currentFilterValue = '';
            } else {
                this.currentFilterValue = model.filter;
            }
        },
        // onParentModelChanged(parentModel) {
        //     // When the filter is empty we will receive a null value here
        //     if (!parentModel) {
        //         this.currentValue = '';
        //     } else {
        //         this.currentValue = parentModel.filter;
        //     }
        // },
    }
});

const VendorColRenderer = Vue.extend({
    template: `
    <div class="h-100 d-flex align-items-center justify-content-between gap-2 w-100">
        <div class="ml-2">
            <a v-if="vendorUrl" :href="vendorUrl" target="_blank" class="text-primary text-wrap">
                {{vendorName}}
            </a>
            <span v-else class="text-wrap" style="line-height: 1.4">{{vendorName}}</span>
        </div>
        <b-button 
            v-if="vendorId" 
            size="sm" 
            variant="minimal-primary"
            class="font-size-70"
            style="padding: 2px 6px;"
            @click="startAdd"
        >
            <b-icon icon="plus-circle" title="Add Document"></b-icon>
        </b-button>
    </div>`,
    computed: {
        vendorName() {
            return this.params.value;
        },
        vendorUrl() {
            return this.params.data?.url || '';
        },
        vendorId() {
            return this.params.data?.id || '';
        },
        gridComponent() {
            // reference to the parent grid component, so we can call methods on it
            return this.params.context.componentParent;
        },
    },
    methods: {
        startAdd() {
            this.gridComponent.startAdd(this.params.data);
        },
    }
});


const VendorFloatingFilterComponent = Vue.extend({
    template: `
    <b-form-input
        :style="{ width: '100%' }" 
        type="search" 
        v-model="currentValue" 
        @input="onInputBoxChanged()"
    ></b-form-input>
    `,
    data: function () {
        return {
            currentValue: null,
        };
    },
    methods: {
        // this.params is { column, filterParams, currentParentModel, suppressFilterButton, parentFilterInstance, showParentFilter, api }
        onInputBoxChanged() {
            if (this.currentValue === '') {
                // Remove the filter
                this.params.parentFilterInstance((instance) => {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }
            this.params.parentFilterInstance((instance) => {
                instance.onFloatingFilterChanged('contains', this.currentValue);
            });
        },
        onParentModelChanged(parentModel) {
            // When the filter is empty we will receive a null value here
            if (!parentModel) {
                this.currentValue = '';
            } else {
                this.currentValue = parentModel.filter;
            }
        },
    },
});


export {
    StatusRenderer,
    ReqStatusRenderer,
    CompItemHeaderRenderer,
    VendorColHeaderRenderer,
    VendorColRenderer,
    VendorFloatingFilterComponent,
}